import { NgModule } from '@angular/core';
import { SwiperModule } from 'swiper/angular';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DeferLoadModule } from '@trademe/ng-defer-load';

import {
    AvatarComponent,
    ExpandableComponent,
    HorizontallerComponent,
    HorizontallerHeaderDirective,
    HorizontallerItemComponent,
    HtmlSanitizePipe,
    SearchbarAdvRootDirective,
    SearchbarAutocompleteTemplateDirective,
    SearchbarComponent,
    SearchbarOptionsComponent,
    WorldMapComponent,
} from '@exl-ng/mulo-common';
import {
    CenteredBlockLayoutComponent,
    FeaturedTileComponent,
} from '@exl-ng/mulo-views';

import { SharedModule } from '../shared/shared.module';
import { CitationsModule } from '../parts/citations/citations.module';
import { AdvancedSearchModule } from '../parts/advanced-search/advanced-search.module';

import { PortalRoutingModule } from './portal-routing.module';
import { PortalComponent } from './portal.component';
import { PortalTitleComponent } from './portal-title/portal-title.component';
import { PortalIntroComponent } from './portal-intro/portal-intro.component';
import { PortalDownloadMapComponent } from './portal-download-map/portal-download-map.component';
import { DownloadMapDatatableComponent } from './portal-download-map/download-map-datatable/download-map-datatable.component';
import { PortalMetricsComponent } from './portal-metrics/portal-metrics.component';
import { PortalUsageComponent } from './portal-usage/portal-usage.component';
import { PortalFeaturedComponent } from './portal-featured/portal-featured.component';
import { PortalAdditionsComponent } from './portal-additions/portal-additions.component';
import { PortalFreeLinksComponent } from './portal-free-links/portal-free-links.component';
import { AdditionsDatatableComponent } from './portal-additions/additions-datatable/additions-datatable.component';
import { PortalResearchersComponent } from './portal-researchers/portal-researchers.component';
import { PortalFeaturedCollectionsComponent } from './portal-featured-collections/portal-featured-collections.component';
import { ContentLoaderModule } from '@ngneat/content-loader';

@NgModule({
    imports: [
        SharedModule,
        PortalRoutingModule,
        CenteredBlockLayoutComponent,
        SwiperModule,
        WorldMapComponent,
        NgxChartsModule,
        DeferLoadModule,
        CitationsModule,
        ExpandableComponent,
        SearchbarComponent,
        SearchbarOptionsComponent,
        SearchbarAutocompleteTemplateDirective,
        SearchbarAdvRootDirective,
        HorizontallerComponent,
        HorizontallerHeaderDirective,
        HorizontallerItemComponent,
        AdvancedSearchModule,
        AvatarComponent,
        FeaturedTileComponent,
        HtmlSanitizePipe,
        ContentLoaderModule,
        PortalComponent,
        PortalTitleComponent,
        PortalIntroComponent,
        PortalDownloadMapComponent,
        DownloadMapDatatableComponent,
        AdditionsDatatableComponent,
        PortalMetricsComponent,
        PortalUsageComponent,
        PortalFeaturedComponent,
        PortalAdditionsComponent,
        PortalFreeLinksComponent,
        PortalResearchersComponent,
        PortalFeaturedCollectionsComponent,
    ],
    exports: [PortalMetricsComponent],
})
export class PortalModule {}
